const React = require('react');

const Content = require('../common/Content.jsx');
const Token = require('../utility/Token.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');
const Name = require('../utility/Name.jsx');

const parsing = {
    contactMeta: (props, keyword, options) => {
        const data = props.data || {};
        const blockConfig = props.config && props.config.config && props.config.config.Block || {};
        const address = blockConfig.addressType == 'billing' ? data.BilledToAddress : data.BilledToShippingAddress;
        let replaceString = '';
        switch (keyword) {
            // case Token.Address.City:
            //     if (address && !Utilities.isNullOrWhitespace(address.City)) {
            //         replaceString = Token.getReplacementString(address.City, options);
            //     }
            //     break;
            case Token.Address.Country:
                if (address && !Utilities.isNullOrWhitespace(address.Country)) {
                    replaceString = Token.getReplacementString(address.Country, options);
                }
                break;
            case Token.Address.Line1:
                if (address && !Utilities.isNullOrWhitespace(address.LineOne)) {
                    replaceString = Token.getReplacementString(address.LineOne, options);
                }
                break;
            case Token.Address.Line2:
                if (address && !Utilities.isNullOrWhitespace(address.LineTwo)) {
                    replaceString = Token.getReplacementString(address.LineTwo, options);
                }
                break;
            case Token.Address.Location:
                if (address && !Utilities.isNullOrWhitespace(address.LocationWithZip)) {
                    replaceString = Token.getReplacementString(address.LocationWithZip, options);
                }
                break;
            case Token.Address.Name:
                if (address && !Utilities.isNullOrWhitespace(address.Name)) {
                    replaceString = Token.getReplacementString(address.Name, options);
                }
                break;
            // case Token.Address.State:
            //     if (address && !Utilities.isNullOrWhitespace(address.State)) {
            //         replaceString = Token.getReplacementString(address.State, options);
            //     }
            //     break;
            // case Token.Address.Zip:
            //     if (address && !Utilities.isNullOrWhitespace(address.Zip)) {
            //         replaceString = Token.getReplacementString(address.Zip, options);
            //     }
            //     break;
            case Token.CompanyName:
                if (!Utilities.isNullOrWhitespace(data.BilledToCompany)) {
                    replaceString = Token.getReplacementString(data.BilledToCompany, options);
                }
                break;
            case Token.Email:
                if (!Utilities.isNullOrWhitespace(data.BilledToEmail)) {
                    replaceString = Token.getReplacementString(data.BilledToEmail, options);
                }
                break;
            case Token.Name:
                if (!Utilities.isNullOrWhitespace(data.BilledToName)) {
                    replaceString = Token.getReplacementString(data.BilledToName, options);
                }
                break;
            case Token.Phone.Home:
                if (!Utilities.isNullOrWhitespace(data.BilledToPhoneHome)) {
                    replaceString = Token.getReplacementString(data.BilledToPhoneHome, options);
                }
                break;
            case Token.Phone.Mobile:
                if (!Utilities.isNullOrWhitespace(data.BilledToPhoneMobile)) {
                    replaceString = Token.getReplacementString(data.BilledToPhoneMobile, options);
                }
                break;
            case Token.Phone.Other:
                if (!Utilities.isNullOrWhitespace(data.BilledToPhoneOther)) {
                    replaceString = Token.getReplacementString(data.BilledToPhoneOther, options);
                }
                break;
            case Token.SpouseName:
                if (!Utilities.isNullOrWhitespace(data.BilledToSpouseName)) {
                    replaceString = Token.getReplacementString(data.BilledToSpouseName, options);
                }
                break;
            case Token.TaxId:
                if (!Utilities.isNullOrWhitespace(data.TaxId)) {
                    replaceString = Token.getReplacementString(data.TaxId, options);
                }
                break;
            default:
                replaceString = undefined;
                break;
        }
        return replaceString;
    }
}
function _ContactMeta(props) {
    let empty = false;
    if (props.config && props.config.config && props.config.config.Block && props.config.config.Block.design && props.config.config.Block.addressType == 'shipping') {
        empty = true;
        const tokens = [Token.Address.Line1, Token.Address.Line2, Token.Address.Location, Token.Address.Country];
        for (let token of tokens) {
            if (!Token.isTokenPresent(token, props.config.config, Name.Block.Client.ContactMeta) || !parsing.contactMeta(props, token)) {
                continue;
            }
            empty = false;
            break;
        }
    }
    if (!props.builder && empty) {
        return null;
    }
    return <Content.Value {...props} value={props.content} />
}
const ContactMeta = Token.withContentTokenParsing(
    _ContactMeta,
    {
        extraParseConditionHandler: (props) => {
            if (props.config && props.config.config && props.config.config.Block) {
                return [props.config.config.Block.addressType];
            }
            return [];
        }
    },
    parsing.contactMeta
);
const Tokens = () => [
    Token.getWrappedTokenConfig('Contact Name', Token.Name),
    Token.getWrappedTokenConfig('Spouse Name', Token.SpouseName),
    Token.getWrappedTokenConfig('Company Name', Token.CompanyName),
    Token.getWrappedTokenConfig('Address Name', Token.Address.Name),
    Token.getWrappedTokenConfig('Address Line 1', Token.Address.Line1),
    Token.getWrappedTokenConfig('Address Line 2', Token.Address.Line2),
    Token.getWrappedTokenConfig('Location', Token.Address.Location),
    // Token.getWrappedTokenConfig('City', Token.Address.City),
    // Token.getWrappedTokenConfig('State', Token.Address.State),
    // Token.getWrappedTokenConfig('Zip', Token.Address.Zip),
    Token.getWrappedTokenConfig('Country', Token.Address.Country),
    Token.getWrappedTokenConfig('Home Phone', Token.Phone.Home),
    Token.getWrappedTokenConfig('Mobile Phone', Token.Phone.Mobile),
    Token.getWrappedTokenConfig('Other Phone', Token.Phone.Other),
    Token.getWrappedTokenConfig('Email Address', Token.Email),
    Token.getWrappedTokenConfig('Tax ID', Token.TaxId)
];
const TypeConfig = {
    panel: {
        block: (allowAddressTypeChange = false) => {
            const group = 'block';
            const options = [];
            if (allowAddressTypeChange) {
                options.push({
                    display: 'Address Type',
                    group,
                    name: 'addressType',
                    options: [
                        { display: 'Billing', value: 'billing' },
                        { display: 'Shipping', value: 'shipping' }
                    ],
                    type: 'dropdown',
                    value: 'billing'
                });
            }
            options.push({
                display: 'Display Text',
                fullWidth: true,
                group,
                name: 'design',
                type: 'rich-text-collateral',
                value: `${Utilities.wrapTextForEditor({ text: 'Contact', textExtras: `style="font-weight:bold;"` })}${Utilities.wrapTextForEditor({ text: `{${Token.Name}("before":"","after":"")}`, token: Token.Name })}${Utilities.wrapTextForEditor({ text: `{${Token.SpouseName}("before":"","after":"")}`, token: Token.SpouseName })}${Utilities.wrapTextForEditor({ text: `{${Token.CompanyName}("before":"","after":"")}`, token: Token.CompanyName })}${Utilities.wrapTextForEditor({ text: `{${Token.Address.Line1}("before":"","after":"")}`, token: Token.Address.Line1 })}${Utilities.wrapTextForEditor({ text: `{${Token.Address.Line2}("before":"","after":"")}`, token: Token.Address.Line2 })}${Utilities.wrapTextForEditor({ text: `{${Token.Address.Location}("before":"","after":"")}`, token: Token.Address.Location })}${Utilities.wrapTextForEditor({ text: `{${Token.Address.Country}("before":"","after":"")}`, token: Token.Address.Country })}${Utilities.wrapTextForEditor({ text: `{${Token.Phone.Home}("before":"","after":"")}`, token: Token.Phone.Home })}${Utilities.wrapTextForEditor({ text: `{${Token.Phone.Mobile}("before":"","after":"")}`, token: Token.Phone.Mobile })}${Utilities.wrapTextForEditor({ text: `{${Token.Phone.Other}("before":"","after":"")}`, token: Token.Phone.Other })}${Utilities.wrapTextForEditor({ text: `{${Token.Email}("before":"","after":"")}`, token: Token.Email })}`
            });
            return { group, label: 'Design', options };
        },
        style: () => _TypeConfig.panel.layoutStyleV2('style', 'Layout')
    }
};

module.exports = {
    Component: ContactMeta,
    Tokens,
    TypeConfig
};